//值是函数集
export default{
	//是否移动端
	changeIsMobile(state,data){
		state.isMobile = data
	},
	
	changeNowRouteName(state,data){
		state.nowRouteName = data
	},
	
	// 屏幕高度
	changeWindow(state,data){
		state.winW = data.winW
		state.winH = data.winH
	},
	
	// PC头部导航和当前选中
	changeNavList(state,data){
		state.navList = data
	},
	changeNavCode(state,code){
		state.nowNavCode = code
	},
	changeNavId(state,id){
		state.nowNavId = id
	},
	
	// PC端首尾高度
	changeHeadHeight(state,val){
		state.headerHeight = val
	},
	changeFootHeight(state,val){
		state.footerHeight = val
	},
	changeOrgId(state,val){
		state.orgId = val
	},
}


// WEBPACK FOOTER //
// ./src/store/mutations.js